import React from 'react'
import styled from 'styled-components'
import * as theme from '../theme'

const LabelElement = styled.label`
   position: relative;
   font-weight: bold;
   font-size: ${theme.fontSize.s};
   color: ${theme.color.primary};
`

const LabelRequried = styled(LabelElement)`
   &:after {
      content: '*';
      color: ${theme.color.orange};
      padding: 0 ${theme.spacing.xs};
   }
`

export const Label = ({ required, children, ...props }) => {
   if (required) {
      return <LabelRequried {...props}>{children}</LabelRequried>
   } else {
      return <LabelElement {...props}>{children}</LabelElement>
   }
}
